import React from "react";

const ModalWrapper = ({ open, title, children, onClose, size = "modal-lg" }) => {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

const renderNivelOptions = (niveles = [], loading) => {
  if (loading) {
    return <option value="">Cargando niveles...</option>;
  }

  if (!niveles.length) {
    return <option value="">No hay niveles disponibles</option>;
  }

  return [
    <option value="" key="ninguno">
      Sin nivel requerido
    </option>,
    ...niveles.map((nivel) => (
      <option key={nivel.id} value={nivel.id}>
        {nivel.nombre}
      </option>
    )),
  ];
};

export default function EspecialidadesFormModal({
  modal,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  savingNuevo,
  savingEditar,
  deleting,
  especialidadSeleccionada,
  cerrarModal,
  handleCrearEspecialidad,
  handleActualizarEspecialidad,
  handleEliminarEspecialidad,
  niveles,
  nivelesLoading,
  canUpdate = true,
  canDelete = true,
}) {
  return (
    <>
      <ModalWrapper open={modal === "nuevo"} title="Registrar nueva especialidad" onClose={cerrarModal}>
        <form onSubmit={handleCrearEspecialidad}>
          <div className="modal-body pt-0">
            <div className="mb-3">
              <label className="form-label fw-semibold">Nombre</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej. Custodia y transporte"
                value={formNuevo.nombre}
                onChange={(e) => setFormNuevo((prev) => ({ ...prev, nombre: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Descripcion</label>
              <textarea
                className="form-control"
                rows={3}
                placeholder="Describe brevemente la especialidad"
                value={formNuevo.descripcion}
                onChange={(e) => setFormNuevo((prev) => ({ ...prev, descripcion: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Nivel requerido</label>
              <select
                className="form-select"
                value={formNuevo.nivel_requerido_id ?? ""}
                onChange={(e) =>
                  setFormNuevo((prev) => ({
                    ...prev,
                    nivel_requerido_id: e.target.value ? Number(e.target.value) : "",
                  }))
                }
                disabled={nivelesLoading}
              >
                {renderNivelOptions(niveles, nivelesLoading)}
              </select>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="especialidadNuevaActiva"
                checked={formNuevo.activo}
                onChange={(e) => setFormNuevo((prev) => ({ ...prev, activo: e.target.checked }))}
              />
              <label className="form-check-label" htmlFor="especialidadNuevaActiva">
                {formNuevo.activo ? "Especialidad activa" : "Especialidad inactiva"}
              </label>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={cerrarModal}
              disabled={savingNuevo}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={savingNuevo}>
              {savingNuevo ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Guardando...
                </>
              ) : (
                "Guardar especialidad"
              )}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "editar" && canUpdate}
        title={`Editar especialidad${especialidadSeleccionada ? `: ${especialidadSeleccionada.nombre}` : ""}`}
        onClose={cerrarModal}
      >
        <form onSubmit={handleActualizarEspecialidad}>
          <div className="modal-body pt-0">
            <div className="mb-3">
              <label className="form-label fw-semibold">Nombre</label>
              <input
                type="text"
                className="form-control"
                value={formEditar.nombre}
                onChange={(e) => setFormEditar((prev) => ({ ...prev, nombre: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Descripcion</label>
              <textarea
                className="form-control"
                rows={3}
                value={formEditar.descripcion}
                onChange={(e) => setFormEditar((prev) => ({ ...prev, descripcion: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Nivel requerido</label>
              <select
                className="form-select"
                value={formEditar.nivel_requerido_id ?? ""}
                onChange={(e) =>
                  setFormEditar((prev) => ({
                    ...prev,
                    nivel_requerido_id: e.target.value ? Number(e.target.value) : "",
                  }))
                }
                disabled={nivelesLoading}
              >
                {renderNivelOptions(niveles, nivelesLoading)}
              </select>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="especialidadEditarActiva"
                checked={formEditar.activo}
                onChange={(e) => setFormEditar((prev) => ({ ...prev, activo: e.target.checked }))}
              />
              <label className="form-check-label" htmlFor="especialidadEditarActiva">
                {formEditar.activo ? "Especialidad activa" : "Especialidad inactiva"}
              </label>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={cerrarModal}
              disabled={savingEditar}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={savingEditar || !canUpdate}>
              {savingEditar ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Guardando...
                </>
              ) : (
                "Guardar cambios"
              )}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "eliminar" && canDelete}
        title="Eliminar especialidad"
        onClose={cerrarModal}
        size="modal-md"
      >
        <div className="modal-body pt-0">
          <p className="mb-2">
            Estas a punto de eliminar la especialidad{" "}
            <strong>{especialidadSeleccionada?.nombre || "seleccionada"}</strong>.
          </p>
          <p className="text-muted mb-0">
            Esta accion no removera historicos, pero evitara que se utilice en nuevos registros.
          </p>
        </div>
        <div className="modal-footer border-0 pt-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={cerrarModal}
            disabled={deleting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleEliminarEspecialidad}
            disabled={deleting || !canDelete}
          >
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Eliminando...
              </>
            ) : (
              "Eliminar"
            )}
          </button>
        </div>
      </ModalWrapper>
    </>
  );
}
